import { makeAutoObservable, runInAction } from "mobx"
import {authApi} from "../api/auth.js";
import jwtDecode from "jwt-decode";

export class AuthenticationStore {
    authentication = null;
    authApi = null;
    constructor(authApi) {
        makeAutoObservable(this);
        this.authApi = authApi;
        let authStr = localStorage.getItem("authentication");
        if (authStr){
            let auth = JSON.parse(authStr);
            this.authentication = new Authentication(
                auth.username, auth.firstName, auth.lastName, auth.orgName, auth.orgId,
                auth.orgType, auth.reseller, auth.role, auth.jwtToken, auth.refreshToken,
                auth.authProvider || "BCTC", auth.isExternalOnly === true
            );
        }
    }
    async signIn(username, password) {
        let result = await authApi.login(username, password);
        this.setAuthInfo(result);
    }

    async completeExternalSession(sessionId) {
        let result = await authApi.getExternalSession(sessionId);
        this.setAuthInfo(result);
    }

    setAuthInfo(result) {
        runInAction(() =>{
            let claims = jwtDecode(result.jwtToken);
            let reseller = claims.reseller === 'true';
            let isExternalOnly = claims.isExternalOnly === 'true';
            this.authentication = new Authentication(
                claims.username, claims.firstName, claims.lastName, claims.orgName, parseInt(claims.orgId), claims.orgType,
                reseller, claims.role, result.jwtToken, result.refreshToken, claims.authProvider || "BCTC", isExternalOnly
            );
            localStorage.setItem("authentication", JSON.stringify(this.authentication));
        });
    }

    async refreshToken() {
        if (this.authentication) {
            try {
                let result = await authApi.refreshToken(this.authentication.jwtToken, this.authentication.refreshToken);
                this.setAuthInfo(result);
            } catch (e){
                console.warn("Could not refresh token. Logging out.", e);
                this.logout();
            }
        }
    }

    signedIn() {
        return this.authentication !== null;
    }

    logout() {
        this.authentication = null;
        localStorage.removeItem("authentication");
    }

    updateName(firstName, lastName) {
        runInAction(() => {
            if (this.authentication) {
                this.authentication.firstName = firstName;
                this.authentication.lastName = lastName;
                localStorage.setItem("authentication", JSON.stringify(this.authentication));
            }
        });
    }

    isAdminRole(){
        if (this.authentication){
            return this.authentication.role === 'SysAdmin' || this.authentication.role === 'Masquerader' ||
                this.authentication.role === 'SuperUser'
        }
        return false;
    }

}

export class Authentication {
    username = null;
    firstName = null;
    lastName = null;
    orgName =  null;
    orgId = null;
    reseller = false;
    jwtToken = null;
    refreshToken = null;
    orgType = null;
    role = null;
    authProvider = "BCTC";
    isExternalOnly = false;

    constructor(username, firstName, lastName, orgName, orgId, orgType, reseller, role, jwtToken, refreshToken, authProvider, isExternalOnly) {
        this.username = username;
        this.firstName = firstName;
        this.lastName = lastName;
        this.orgName = orgName;
        this.orgId = orgId;
        this.orgType = orgType;
        this.jwtToken = jwtToken;
        this.refreshToken = refreshToken;
        this.role = role;
        this.reseller = reseller;
        this.authProvider = authProvider || "BCTC";
        this.isExternalOnly = isExternalOnly === true;
    }

}
